const getDV = (n: number): string => {
  let M = 0;
  let S = 1;
  for (let value = n; value > 0; value = Math.floor(value / 10)) {
    S = (S + (value % 10) * (9 - (M++ % 6))) % 11;
  }
  return S ? (S - 1).toString() : 'K';
};

/**
 * Normalises a Chilean RUT input ("12.345.678-9", "12345678-9", "123456789") into
 * the canonical "12.345.678-9" form. Returns null when the input is not a valid RUT.
 */
const formatRut = (raw: string): string | null => {
  const cleaned = raw.replace(/\./g, '').replace(/\s/g, '').replace(/‐/g, '-').toUpperCase();
  if (!cleaned) return null;

  let body: string;
  let dv: string;
  if (cleaned.includes('-')) {
    [body, dv] = cleaned.split('-');
  } else {
    body = cleaned.slice(0, -1);
    dv = cleaned.slice(-1);
  }

  if (!/^\d+$/.test(body) || !/^[0-9K]$/.test(dv)) return null;
  const numericBody = parseInt(body, 10);
  if (!Number.isFinite(numericBody) || numericBody <= 0) return null;
  if (getDV(numericBody) !== dv) return null;

  const grouped = body
    .split('')
    .reverse()
    .join('')
    .match(/.{1,3}/g)
    ?.map((g) => g.split('').reverse().join(''))
    .reverse()
    .join('.');
  return `${grouped}-${dv}`;
};

export default formatRut;
